import {
  AgxColumn,
  AgxEntityStatistics,
  AgxPartnershipIndicator,
} from '@urbanx/agx.ui-components2'
import { PartnershipDetailsPartnershipLevel, StatsWithTarget } from '@urbanx/agx.rex.client'
import { Suspense } from 'react'
import { CurrentReviewPeriodPartnershipInformation } from 'services/functions/rex/useStaffGetCurrentPartnershipInformation'
import useStaffGetUpcomingSettlementsForAgency from 'services/functions/rex/useStaffGetUpcomingSettlementsForAgency'
import UpcomingSettlements from '../UpcomingSettlements/UpcomingSettlements'

interface PartnershipTabProps {
  entityId: string
  entityNumbers: StatsWithTarget
  currentReviewPeriodDetails:
    | CurrentReviewPeriodPartnershipInformation
    | undefined
  isPreviousYear: boolean
  custumizedPartnershipAgreement: boolean
}

const PartnershipTab = ({
  entityId,
  entityNumbers,
  currentReviewPeriodDetails,
  isPreviousYear = false,
  custumizedPartnershipAgreement = false,
}: PartnershipTabProps) => {
  const { data: upcomingSettlements, isPending: upcomingSettlementsPending } =
    useStaffGetUpcomingSettlementsForAgency(entityId)

  return (
    <AgxColumn fill gap="spacing-3xl">
      <Suspense fallback={<div>Loading...</div>}>
        <AgxColumn fill gap="spacing-2xl">
          {!custumizedPartnershipAgreement && (
            <AgxPartnershipIndicator
              partnershipLevel={
                currentReviewPeriodDetails?.partnershipLevel ??
                PartnershipDetailsPartnershipLevel.Bronze
              }
              reviewDate={
                currentReviewPeriodDetails?.nextReviewDate ?? new Date()
              }
              currentCommission={
                currentReviewPeriodDetails?.currentCommission ?? 0
              }
              commissionTargetAdjustment={
                currentReviewPeriodDetails?.commissionTargetAdjustment ?? 0
              }
            />
          )}
          <AgxEntityStatistics
            loading={false}
            personalStatistics={entityNumbers}
          />
        </AgxColumn>
        {!isPreviousYear && (
          <AgxColumn fill gap="spacing-xl">
            <UpcomingSettlements
              loading={upcomingSettlementsPending}
              upcomingSettlementsForAgency={upcomingSettlements}
            />
          </AgxColumn>
        )}
      </Suspense>
    </AgxColumn>
  )
}

export default PartnershipTab
